import { useEffect, useState } from 'react';
import { useNotificationsToken } from '~/services/user';
import { useCompanySocketConnection } from '~/sockets/channels/company-channel';
import { useUserSocketConnection } from '~/sockets/channels/user-channel';
import { useSibillSocket } from '~/state/notifications/socket';

const useEnsureSocketConnection = (): boolean => {
  const [connection, setConnection] = useState(false);
  const { connect, disconnect } = useSibillSocket();

  const { data: token } = useNotificationsToken();

  useCompanySocketConnection(connection);
  useUserSocketConnection(connection);

  useEffect(() => {
    if (token) {
      connect(token).then(() => setConnection((x) => !x));
    }
    return () => {
      disconnect();
    };
  }, [connect, disconnect, token]);

  return connection;
};

export default useEnsureSocketConnection;
